import { frenchDOMTOMList } from 'Config/authenticated/Address';

export default class AddressFrenchDOMTOMAdapter {
    /**
     * @param {object} address
     */
    set(address) {
        this.address = address;
        return this;
    }

    supports() {
        return (
            this.address.countryCode == 'fr' && this.doesPostcodeMatchDOMTOM(this.address.postcode)
        );
    }

    adapt() {
        if (!this.supports()) {
            return this.address;
        }

        const DOMTOMMatched = frenchDOMTOMList.find(
            (domtom) => domtom.zip == this.matchDOMTOMFromPostcode(this.address.postcode),
        );
        // overwrite country
        this.address.countryCode = DOMTOMMatched.code.toLowerCase();
        this.address.country = DOMTOMMatched.name;
        // reset state
        this.address.administrative = '';

        return this.address;
    }

    /**
     * @param {string} zip
     */
    doesPostcodeMatchDOMTOM(zip) {
        return !!this.matchDOMTOMFromPostcode(zip);
    }

    /**
     * @param {string} zip
     */
    matchDOMTOMFromPostcode(zip) {
        const match = new RegExp(
            '^(' + frenchDOMTOMList.map((domtom) => domtom.zip).join('|') + ')[\\d]*',
        ).exec(zip);
        return match !== null ? match[1] : null;
    }
}
